import { render, staticRenderFns } from "./AcceptRulesText.vue?vue&type=template&id=6f20ed0c&functional=true"
import script from "./AcceptRulesText.vue?vue&type=script&lang=js"
export * from "./AcceptRulesText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports